import { createContext } from 'react'

import { AzureAdContextProps } from './types'

export const AzureAdContext = createContext<AzureAdContextProps>(null!)
